import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';


import { DialogContainerDirective, DialogContainerService, DialogService } from '@progress/kendo-angular-dialog';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';

import { routes } from './app.routes';

import { HttpRequestInterceptor } from './core/interceptor/http-request.Interceptor';
import { TimeoutInterceptor, DEFAULT_TIMEOUT } from './core/interceptor/timeout.Interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { BusViewService } from './services/bus-view.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `./locale/`, '.json?v=[version]');
}

export const provideTranslation = () => ({
  defaultLanguage: localStorage.getItem('locale') ?? 'zh-HK',
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
});
export const appConfig: ApplicationConfig = {
  providers: [
    DialogService,
    DialogContainerService,
    DialogContainerDirective,
    DatePipe,
    BusViewService,
    provideHttpClient(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    { provide: ICON_SETTINGS, useValue: { type: 'font' } },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    {
      provide: DEFAULT_TIMEOUT,
      useValue: 60000,
    },
    importProvidersFrom([TranslateModule.forRoot(provideTranslation())])
  ],
};
